<ng-template #masterView>
  <ng-content select="app-driveb-master-view"></ng-content>
</ng-template>

<ng-template #detailView>
  <ng-content select="app-driveb-detail-view"></ng-content>
</ng-template>

<mat-sidenav-container
  class="container"
  (backdropClick)="closeOnBackdropClick ? closeTrigger() : null"
>
  <mat-sidenav-content class="container-content" #sidenavcontent>
    <!-- Master -->
    <ng-container *ngTemplateOutlet="masterView"></ng-container>
  </mat-sidenav-content>

  <mat-sidenav
    *ngIf="!useDialog"
    id="detailContainer"
    #sidenav
    (openedChange)="detailsOpened($event)"
    [opened]="isDetailsShown"
    [disableClose]="true"
    (keydown.escape)="closeOnEscape ? closeTrigger() : null"
    (closed)="detailsClosed()"
    [mode]="useSlideoverSidebarMode ? 'over' : 'side'"
    position="end"
    class="sidebar-content"
    [class.container-content-padded]="detailViewComponent?.isPadded"
    [class.sidebar-full-size]="useSlideoverSidebarMode"
    [class.sidebar-visible]="!useSlideoverSidebarMode"
  >
    <app-driveb-resize-handle
      *ngIf="useResizeHandle && !useSlideoverSidebarMode"
      [position]="'left'"
      [offset]="resizeHandleOffset"
      [minSize]="resizeHandleMinSize"
      [maxSize]="resizeHandleMaxSize"
      (sizeChanged)="resizeHandleSizeChange($event)"
    >
    </app-driveb-resize-handle>
    <ng-container *ngTemplateOutlet="detailView"></ng-container>
  </mat-sidenav>
</mat-sidenav-container>
